import { queryClient } from "@/queryClient"

export type updateRoleQuery = {
  name: string
  permissions: Array<string>
}

export type updateRoleResponse = {
  name: string
  permissions: Array<string>
}

export const updateRole = async (
  roleId: string,
  params: updateRoleQuery
) => {
  const { body } = await api.put<updateRoleResponse>(
    `/users/roles/${roleId}/`,
    { body: params }
  )

  queryClient.invalidateQueries({
    queryKey: [ROLES_QUERY_KEY],
  })
  return body
}
